import _ from "underscore";
import SubnavigationBaseView from "../subnavigationBaseView";
import pageHTML from "./subnavigation.tmpl";

export default class HosSubMenu extends SubnavigationBaseView {
    private readonly template = _.template(pageHTML);

    /* eslint-disable @typescript-eslint/unbound-method */
    events() {
        return {
            "click #hosLogs": this.navigateLogs,
            "click #hosStatus": this.navigateStatus
        } as Backbone.EventsHash;
    }
    /* eslint-enable @typescript-eslint/unbound-method */

    render () {
        if (!this.app.store.getState().mobile.embed) {
            void this.display(this.template({active: this.options.active}));
        }
        return this;
    }

    navigateStatus () {
        this.app.router.navigate("hos", true);
    }

    navigateLogs () {
        this.app.router.navigate("hos/tabs/logs/logs", true);
    }
}
